
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 7H7v18h11c2.8 0 5-2.2 5-5 0-2.2-1.4-4-3.3-4.7.8-.9 1.3-2 1.3-3.3 0-2.8-2.2-5-5-5zm-7 8V9h7c1.7 0 3 1.3 3 3s-1.3 3-3 3H9zm0 8v-6h9c1.7 0 3 1.3 3 3s-1.3 3-3 3H9zm7-18c3.9 0 7 3.1 7 7 0 .9-.2 1.8-.5 2.6C24 15.9 25 17.9 25 20c0 3.9-3.1 7-7 7H5V5h11zm-5 6v2h5c.6 0 1-.4 1-1s-.4-1-1-1h-5zm0 8v2h7c.6 0 1-.4 1-1s-.4-1-1-1h-7z"}})])
          )
        }
      }
    